<div class="div-toolbar">
    <app-toolbar/>
</div>
@if (!environment.production) {
    <div class="test-banner" matTooltip="RIS Testumgebung">
        <mat-icon>developer_board</mat-icon>
    </div>
}

<div class="background" [ngClass]="{'small-height' : (screenHeight < 900)}">
    <div class="content" role="main">
        <router-outlet/>
    </div>
</div>
